import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingFallback from "Components/LoadingFallback/LoadingFallback";

const RedirectAuthenticatedRoot = ({ children }) => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

  if (isLoading) {
    return <LoadingFallback />;
  }

  if (isAuthenticated) {
    return <Navigate to="/lists" replace />;
  }

  return children;
};

export default RedirectAuthenticatedRoot;
